import Head from 'next/head';

import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import * as ST from './styled';

export const TariffCardPlug = ({ ...rest }): JSX.Element => {
    const isWebpUsed = useWebp();

    return (
        <ST.Wrapper {...rest}>
            <Head>
                <link rel='preload' as='image' href='/static/images/tariff-lines/bg-wave.webp' type='image/webp'/>
            </Head>
            <ST.TariffsPlug isWebpUsed={isWebpUsed}>
                <ST.PlugContent>
                    <ST.SvgIcon width='76' height='26' aria-label='logo'>
                        <use href='/static/images/logo-short-sprite.svg#logo-short' />
                    </ST.SvgIcon>
                    {'Таких тарифов не нашлось. \n Попробуйте изменить фильтр.'}
                </ST.PlugContent>
            </ST.TariffsPlug>
        </ST.Wrapper>
    );
};
